<template>
  <section class="integration-detail-card">
    <header class="integration-detail-card__header">
      <h3>{{ title }}</h3>
      <div v-if="$slots.actions" class="integration-detail-card__actions">
        <slot name="actions" />
      </div>
    </header>
    <slot />
  </section>
</template>

<script>
export default {
  name: 'IntegrationDetailCard',
  props: {
    title: {
      type: String,
      required: true
    }
  }
}
</script>
